import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";

const DeliveryChargeTemplateListComponent = loadable(
  () => import("../../components/DeliveryChargeTemplate/DeliveryChargeTemplateList")
);

const DeliveryChargeTemplateList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Rate Template</span>
      </div>
      <DeliveryChargeTemplateListComponent />
    </>
  );
};



export default DeliveryChargeTemplateList
